module.exports = "/_next/static/images/quolum-b31ee37c13eb82bc9f1c569a261345d6.png";